
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphNodeGrid extends Serenity.EntityGrid<GraphNodeRow, any> {
        protected getColumnsKey() { return 'Visualizer.GraphNode'; }
        protected getDialogType() { return GraphNodeDialog; }
        protected getIdProperty() { return GraphNodeRow.idProperty; }
        protected getLocalTextPrefix() { return GraphNodeRow.localTextPrefix; }
        protected getService() { return GraphNodeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}